/**
 * Copyright © 2026 Adnuntius AS.
 */
import {NgModule} from '@angular/core';

import {AdvertisingSharedModule} from '../advertising/advertising-shared.module';
import {CreativeUserStatesComponent} from '../common/directives/creative-user-states';
import {RetailProductListPageComponent} from '../retail-product/retail-product-list-page.component';
import {CreativeFromLineItemCopyModalComponent} from './creative-from-line-item-copy-modal.component';
import {LineItemAnalysisPageComponent} from './line-item-analysis-page.component';
import {LineItemBulkActionModalComponent} from './line-item-bulk-action-modal.component';
import {LineItemContextActionsComponent} from './line-item-context-actions.component';
import {LineItemCopyModalComponent} from './line-item-copy-modal.component';
import {LineItemCpmFeesModalComponent} from './line-item-cpm-fees-modal.component';
import {LineItemCreativeListComponent} from './line-item-creative-list.component';
import {LineItemDiagnosticsPageComponent} from './line-item-diagnostics-page.component';
import {LineItemEditPageComponent} from './line-item-edit-page.component';
import {LineItemListContextActionsComponent} from './line-item-list-context-actions.component';
import {LineItemListFiltersComponent} from './line-item-list-filters.component';
import {LineItemListPageComponent} from './line-item-list-page.component';
import {LineItemRetailProductModalComponent} from './line-item-retail-product-modal.component';
import {LineItemTemplateAnalysisPageComponent} from './line-item-template-analysis-page.component';
import {LineItemTemplateContextActionsComponent} from './line-item-template-context-actions.component';
import {LineItemTemplateCopyModalComponent} from './line-item-template-copy-modal.component';
import {LineItemTemplateListPageComponent} from './line-item-template-list-page.component';
import {MpProductModalComponent} from './mp-product-modal.component';

const LINE_ITEM_COMPONENTS = [
  CreativeFromLineItemCopyModalComponent,
  CreativeUserStatesComponent,
  LineItemAnalysisPageComponent,
  LineItemBulkActionModalComponent,
  LineItemContextActionsComponent,
  LineItemCopyModalComponent,
  LineItemCpmFeesModalComponent,
  LineItemCreativeListComponent,
  LineItemDiagnosticsPageComponent,
  LineItemEditPageComponent,
  LineItemListContextActionsComponent,
  LineItemListFiltersComponent,
  LineItemListPageComponent,
  LineItemRetailProductModalComponent,
  LineItemTemplateAnalysisPageComponent,
  LineItemTemplateContextActionsComponent,
  LineItemTemplateCopyModalComponent,
  LineItemTemplateListPageComponent,
  MpProductModalComponent
];

@NgModule({
  imports: [
    AdvertisingSharedModule,
    RetailProductListPageComponent
  ],
  declarations: LINE_ITEM_COMPONENTS,
  exports: LINE_ITEM_COMPONENTS
})
export class LineItemModule {
}
